import { put, call, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../../constants';
import { AxiosService } from '../../../services';
import { actionTypes } from '../../../types';
import { getAllNicheFailure, getAllNicheSuccess } from '../../actions/CampaignMasterActions/getAllNicheActions';

function* getAllNiche({ payload }) {
    try {
        const response = yield call(AxiosService, {
            method: 'get',
            base_url: base_url,
            endPoint: endpoints.getAllNiche,
            isAuth: true,
        });
        console.log('====================================');
        console.log("GET_ALL_NICHE_SUCCESS status :", response.data.status);
        console.log("GET_ALL_NICHE_SUCCESS data :", response.data.response);
        console.log("GET_ALL_NICHE_SUCCESS message :", response.data.message);
        console.log('====================================');
        yield put(
            getAllNicheSuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message
            })
        );
    } catch (error) {
        console.log('====================================');
        console.log("GET_ALL_NICHE_FAILURE status :", error?.response?.status);
        console.log("GET_ALL_NICHE_FAILURE data:", error?.response?.data);
        console.log("GET_ALL_NICHE_FAILURE error :", error);
        console.log('====================================');
        yield put(getAllNicheFailure({
            status: error?.response?.data?.status,
            response: {},
            message: error?.response?.data?.message
        }));
    }
}

function* getAllNicheSaga() {
    yield takeLatest(actionTypes.GET_ALL_NICHE_REQUEST, getAllNiche);
}

export default getAllNicheSaga;